import React from 'react';
import { observer } from 'mobx-react-lite';
import MuiPhoneNumber from 'material-ui-phone-number';
import { InputVariant } from '../../enums/InputVariant';
import { isInvalidPhoneNumber } from '../../utils/phoneNumber';

export const InputFieldPhone: React.FC<{
    id: string;
    value?: string;
    fullWidth: boolean;
    variant?: InputVariant;
    onChange: (value: any) => void;
    disable?: boolean;
}> = observer(({ id, value, fullWidth, onChange, disable, variant }) => {
    return (
        <MuiPhoneNumber
            fullWidth={fullWidth}
            error={isInvalidPhoneNumber(value)}
            required
            id={id}
            margin='normal'
            variant={variant ?? 'outlined'}
            value={value ?? ''}
            onChange={onChange}
            data-cy='user-phone'
            defaultCountry={'ca'}
            onlyCountries={['ca']}
            disabled={disable}
            helperText={isInvalidPhoneNumber(value) ? 'Please input a valid number' : undefined}
        />
    );
});
